import { u as useT, p as jsxRuntimeExports, L as Button } from "./doenetml-NmXDuMHr.js";
import React__default, { useState } from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
import { T as TooltipProvider, a as TooltipAnchor, b as Tooltip } from "./tooltip-provider-Bek2bo6U.js";
const footnote = React__default.memo(function Footnote(props) {
  let { id, SVs } = useDoenetRenderer(props, false);
  let [isVisible, setIsVisible] = useState(false);
  const t = useT();
  if (SVs.hidden) {
    return null;
  }
  const footnoteMessageStyle = {
    padding: "10px",
    borderRadius: "5px",
    backgroundColor: "var(--revealButtonSurface)",
    color: "var(--canvasText)",
    display: "block"
  };
  let footnoteMessage = "";
  if (isVisible) {
    footnoteMessage = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: footnoteMessageStyle, children: SVs.text });
  }
  const buttonStyle = {
    backgroundColor: "var(--canvas)",
    border: "none",
    color: "var(--whiteBlankLink)",
    padding: "0"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { id, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipProvider, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        TooltipAnchor,
        {
          render: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button,
            {
              style: buttonStyle,
              onClick: () => {
                setIsVisible((was) => !was);
              }
            }
          ),
          children: [
            "[",
            SVs.footnoteTag,
            "]"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Tooltip,
        {
          style: {
            backgroundColor: "var(--canvas)",
            color: "var(--canvasText)",
            border: "1px solid var(--canvasText)",
            padding: "0.2em 0.5em"
          },
          children: isVisible ? t("footnote-hide", void 0, "Hide footnote") : t("footnote-show", void 0, "Show footnote")
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "aria-live": "polite", children: footnoteMessage })
  ] });
});
export {
  footnote as default
};
